import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import ModernDatepicker from 'react-modern-datepicker';
import Autocomplete from 'react-autocomplete';
import CurrencyInput from 'react-currency-input';
import ProductsAction from '../../app/store/actions/products';
import PromotionAction from '../../app/store/actions/promotion';
import TimePicker from '../elements/TimePicker';
import ModalComponent from '../modal';

import FIELDS from '../../data/fields';

let productHelper = '';

class PromotionFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startedAt: moment().startOf('day'),
      finalizedAt: moment().add(1, 'day').startOf('day'),
      id: '',
      productId: '',
      showTimer: '',
      type: '',
      value: '',
      percentage: '',
      productDescription: '',
      limit: 10,
      skip: 0,
      message: '',
      success: '',
      showModal: false,
      warning: '',
      released: false,
    };
  }

  componentDidMount() {
    const { limit, skip } = this.state;
    this.props.searchProductsCheckbuy(limit, skip);
    if (this.props.back.location.item) {
      const {
        startedAt, finalizedAt, id, productId, type, value, showTimer, product,
      } = this.props.back.location.item;
      let st;

      if (showTimer) st = 1;
      if (!showTimer) st = 0;
      this.setState({
        startedAt: moment(startedAt),
        finalizedAt: moment(finalizedAt),
        productDescription: product.description,
        id,
        productId,
        type,
        value: type === 'value' ? value : '',
        percentage: type === 'percentage' ? (value * 100).toFixed(0) : '',
        showTimer: st,
      });
    }
  }

  changeModal = () => {
    this.setState({
      showModal: true,
      released: false,
      success: '',
    });
  };

  disableModal = () => {
    this.setState({
      showModal: false,
    });
  };

  renderOrdersCategory = () => (
    <div className="form-main">
      <div className="text-align-modal">
        <h3 className="text-danger"><Translate value="warning" /></h3>
        <h4>{this.state.warning}</h4>
        <div className=" row d-flex justify-content-center mt-5">
          <div>
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => this.disableModal()}
            >
              <Translate value="no" />
            </button>
          </div>
          <div>
            <button
              type="button"
              className="btn btn-primary margin-left-btn-modal"
              onClick={() => this.accepted()}
            >
              <Translate value="yes" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  accepted = async () => {
    await this.setState({
      released: true,
      showModal: false,
    });
    this.createPromotion();
  }

  goBack = () => {
    this.props.back.goBack();
  };

  setOnChange = (productDescription) => {
    this.props.searchProductsCheckbuy(10, productDescription);
    this.setState({ productDescription });
  };


  setSelectedProductId = (description) => {
    const productDescription = description.value;
    this.setState({ productDescription, productId: productHelper.soneparId });
  };

  setSelectedProduct = (item) => {
    productHelper = item;
    return `${item.code} ${item.description}`;
  };

  isValidData = async () => {
    const {
      startedAt, finalizedAt, productId, type, value, percentage, showTimer,
    } = this.state;

    const d1 = moment(startedAt);
    const d2 = moment(finalizedAt);
    const invalidDate = d1 >= d2;
    if (!productId) await this.setState({ message: I18n.t('selectProduct'), success: '' });
    else if (!startedAt) await this.setState({ message: I18n.t('selectDateInit'), success: '' });
    else if (moment().startOf('day').toDate() > d1) {
      await this.setState({ message: I18n.t('dateLess'), success: '' });
    } else if (!finalizedAt) await this.setState({ message: I18n.t('selectDateFinal'), success: '' });
    else if (invalidDate) {
      await this.setState({ message: I18n.t('dateMajor'), success: '' });
    } else if (!type) await this.setState({ message: I18n.t('selectDescount'), success: '' });
    else if (type === 'value' && !value) await this.setState({ message: I18n.t('insertDescount'), success: '' });
    else if
    (type === 'percentage' && !percentage) await this.setState({ message: I18n.t('insertDescount'), success: '' });
    else if (type === 'value' && Number(value.replace(',', '.')) < 0.1) {
      await this.setState({ message: I18n.t('valueMajor'), success: '' });
    } else if (type === 'percentage' && (percentage < 1 || percentage > 99)) {
      await this.setState({ message: I18n.t('valueManjorLess'), success: '' });
    } else if (showTimer === null || showTimer === undefined || showTimer === '') {
      await this.setState({ message: I18n.t('showTime'), success: '' });
    } else {
      return true;
    }
  };

  createPromotion = async () => {
    const {
      startedAt, finalizedAt, productId, type, value, percentage, showTimer, released,
    } = this.state;

    if (await this.isValidData()) {
      try {
        await this.props.createPromotion({
          startedAt,
          finalizedAt,
          productId,
          type,
          value: type === 'value' ? Number(value.replace(',', '.')) : percentage / 100,
          showTimer,
          released,
        });
        this.setState({
          success: I18n.t('promotionCreated'),
          message: '',
          startedAt: moment().startOf('day'),
          finalizedAt: moment().add(1, 'day').startOf('day'),
          productDescription: '',
          id: '',
          productId: '',
          type: '',
          value: '',
          showTimer: '',
          released: false,
        });
      } catch (err) {
        if (err.response && err.response.data && err.response.data.error.code === 31) {
          this.setState({
            warning: I18n.t('existingPromotion'),
          });
          this.changeModal();
        } else if (err.response && err.response.data && err.response.data.error.code === 52) {
          this.setState({ message: I18n.t('dragAndDropPromotionErrorNotReplaced'), success: '' });
        } else {
          this.setState({ message: I18n.t('errorOcurred'), success: '' });
        }
      }
    }
  };

  updatePromotion = async () => {
    const {
      startedAt, finalizedAt, productId, type, value, percentage, showTimer, id,
    } = this.state;

    if (await this.isValidData()) {
      try {
        await this.props.updatePromotion({
          id,
          startedAt,
          finalizedAt,
          productId,
          type,
          value: type === 'value' ? Number(value.replace(',', '.')) : percentage / 100,
          showTimer,
        });
        this.setState({ success: I18n.t('promotionUpdated'), message: '' });
      } catch (err) {
        this.setState({ message: I18n.t('errorOcurred'), success: '' });
      }
    }
  };

  handleDate = (date, type) => {
    const currentDate = this.state[type];

    let currenTime = currentDate.format('HH:mm:ss');
    currenTime = `${date} ${currenTime}`;
    const newDate = moment(currenTime, 'DD-MM-YYYY HH:mm:ss');

    this.setState({
      [type]: newDate,
    });
  }

  setDateTime = async (date, type) => {
    await this.setState({
      [type]: date.clone(),
    });
  }

  render() {
    const {
      startedAt, finalizedAt, productDescription, message, type, value, percentage, success, showTimer, id,
      showModal,
    } = this.state;
    const { products } = this.props;
    return (
      <div className="form-main">
        <ModalComponent
          showButtons
          showOk={false}
          visible={showModal}
          closeModal={() => this.disableModal()}
          type="orderCategory"
          size={{ width: '40%', height: '20%' }}
          id="modalOrderCategory"
          bodyFuncComponent={() => this.renderOrdersCategory()}
        />
        <h2 className="header-form-client"><Translate value="promotionRegister" /></h2>
        <form>

          <div className="form-group search-custom-input">
            <p className="margin-bottom-2"><Translate value="product" /></p>
            <Autocomplete
              getItemValue={item => this.setSelectedProduct(item)}
              items={products || []}
              className="custom-select"
              maxLength={FIELDS.max}
              renderItem={(item, isHighlighted) => (
                <div style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                  {item.code}
                  {' '}
                  {item.description}
                  {' '}
                  {item.product.narrativa}
                </div>
              )}
              value={productDescription}
              onChange={e => this.setOnChange(e.target.value)}
              onSelect={e => this.setSelectedProductId({ value: e })}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="promotionType" /></p>
            <select
              onChange={e => this.setState({ type: e.target.value, value: '' })}
              className="custom-select"
              required
              defaultValue=""
              value={type}
            >
              <option value="" />
              <option value="percentage">{I18n.t('percentage')}</option>
              <option value="value">{I18n.t('value')}</option>
            </select>
            <div className="invalid-feedback"><Translate value="selectPromotionType" /></div>
          </div>

          {type === 'value'
          && (
          <div className="form-group">

            <CurrencyInput
              decimalSeparator=","
              thousandSeparator=""
              value={value}
              className="form-control"
              onChangeEvent={e => this.setState({ value: e.target.value })}
              maxLength={FIELDS.float_max}
            />
          </div>
          )
          }

          {type === 'percentage'
          && (
          <div className="form-group">
            <input
              type="text"
              value={percentage}
              className="form-control"
              onChange={e => this.setState({ percentage: Number(e.target.value) || '' })}
              maxLength={FIELDS.percentage}
            />
          </div>
          )
          }

          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="showTime2" /></p>
            <select
              onChange={e => this.setState({ showTimer: e.target.value })}
              className="custom-select"
              required
              defaultValue=""
              value={showTimer}
            >
              <option value="" />
              <option value="1">{I18n.t('yes')}</option>
              <option value="0">{I18n.t('no')}</option>
            </select>
          </div>

          <div className="form-group form-promotion-picker">
            <p className="margin-bottom-2"><Translate value="dateInit" /></p>
            <div className="inputs">
              <ModernDatepicker
                date={startedAt}
                format="DD-MM-YYYY"
                showBorder
                onChange={date => this.handleDate(date, 'startedAt')}
                placeholder=""
                className="form-control"
              />
              <TimePicker
                date={startedAt}
                setDateTime={date => this.setDateTime(date, 'startedAt')}
              />
            </div>

          </div>

          <div className="form-group form-promotion-picker">
            <p className="margin-bottom-2"><Translate value="dateFinal" /></p>
            <div className="inputs">
              <ModernDatepicker
                date={finalizedAt}
                format="DD-MM-YYYY"
                showBorder
                onChange={date => this.handleDate(date, 'finalizedAt')}
                placeholder=""
                className="form-control"
              />
              <TimePicker
                date={finalizedAt}
                setDateTime={date => this.setDateTime(date, 'finalizedAt')}
              />
            </div>
          </div>

          {success && <p className="color-green margin-top-10">{success}</p>}
          {message && <p className="color-red margin-top-10">{message}</p>}

          <div className="row margin-left-0 margin-top-10">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              <Translate value="return" />
            </button>
            {id
              ? (
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={() => this.updatePromotion()}
                >
                  <Translate value="update" />
                </button>
              )
              : (
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={() => this.createPromotion()}
                >
                  <Translate value="save" />
                </button>
              )
           }
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  searchProductsCheckbuy: (limit, search) => { dispatch(ProductsAction.searchProductsCheckbuy(limit, search)); },
  createPromotion: promotion => dispatch(PromotionAction.createPromotion(promotion)),
  updatePromotion: promotion => dispatch(PromotionAction.updatePromotion(promotion)),
});

const mapStateToProps = state => ({
  products: state.products.productsCheckbuy,
});

export default connect(mapStateToProps, mapDispatchToProps)(PromotionFormComponent);
